var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.356783 0.356783C0.585326 0.128524 0.895126 0.000313855 1.21813 0.000313855C1.54114 0.000313855 1.85094 0.128524 2.07948 0.356783L6.5 4.77567L10.9205 0.356783C11.0336 0.243669 11.1679 0.153942 11.3157 0.0927248C11.4635 0.0315078 11.6219 3.15334e-09 11.7819 0C11.9418 -3.15334e-09 12.1002 0.0315079 12.248 0.0927248C12.3958 0.153942 12.5301 0.243669 12.6432 0.356783C12.7563 0.469897 12.8461 0.604183 12.9073 0.751974C12.9685 0.899765 13 1.05817 13 1.21813C13 1.3781 12.9685 1.5365 12.9073 1.68429C12.8461 1.83208 12.7563 1.96637 12.6432 2.07948L8.22433 6.5L12.6432 10.9205C12.8717 11.149 13 11.4588 13 11.7819C13 12.1049 12.8717 12.4148 12.6432 12.6432C12.4148 12.8717 12.1049 13 11.7819 13C11.4588 13 11.149 12.8717 10.9205 12.6432L6.5 8.22433L2.07948 12.6432C1.85104 12.8717 1.5412 13 1.21813 13C0.895064 13 0.585227 12.8717 0.356783 12.6432C0.128339 12.4148 0 12.1049 0 11.7819C0 11.4588 0.128339 11.149 0.356783 10.9205L4.77567 6.5L0.356783 2.07948C0.128524 1.85094 0.000313855 1.54114 0.000313855 1.21813C0.000313855 0.895126 0.128524 0.585326 0.356783 0.356783Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/close-btn.d1d4262d000e0b6fab730b0e838b6a80.svg";
export { ForwardRef as ReactComponent };